import { useQuery } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { rulebaseApi2Request } from "../lib/rulebase-api2-client/client";

type Session = {
  account_id: string;
  organization_id: string | null;
  account: { email: string; full_name: string };
};

/**
 * Hook to automatically identify users in PostHog when session data is available
 */
export function usePostHogIdentify() {
  const posthog = usePostHog();
  const { data: session } = useQuery({
    queryKey: ["session"],
    queryFn: () => rulebaseApi2Request<Session>("/session"),
  });

  useEffect(() => {
    if (session?.account) {
      const { account, account_id, organization_id } = session;

      const identifiedAccountId = posthog.get_property("$user_id");
      if (
        typeof identifiedAccountId === "string" &&
        identifiedAccountId !== account_id
      ) {
        posthog.reset();
      }

      posthog.identify(account_id, {
        email: account.email,
        name: account.full_name,
      });

      if (organization_id) {
        posthog.group("organization", organization_id, { organization_id });
      }
    }
  }, [session, posthog]);
}
